module.exports = __webpack_public_path__ + "img/6.8bbff952.png";